module.exports = __webpack_public_path__ + "media/images/e-kvitok/bus_white-c1763406ce8f28651962d4d5bc62ce8b.svg";